import {DateField, Panes} from '@management-ui/core';
import React from 'react';

const Fields = ({entity, sectionTitle, fieldTitle, prefix = ''}) => {
  return (
    <Panes
      entity={entity}
      prefix={prefix}
      panes={[
        {
          title: sectionTitle,
          fields: [
            <DateField
              name="date"
              prefix={prefix}
              label={fieldTitle}
            />,
          ]
        }
      ]}
      title={null}
    />
  );
};

export default Fields;
